module.exports = __webpack_public_path__ + "img/cr.2f8e7d9c.svg";